
   <template>
  <div>
    <!-- 新增按钮 -->
        <Input
      v-model="searchId"
      placeholder="输入用户ID"
      style="width: 200px; margin-right: 10px"
    />
   
    <Input
      v-model="roomid"
      placeholder="输入房间id"
      style="width: 200px; margin-right: 10px"
    />

    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal v-model="jpImageModal" title="查看图片" :footer-hide="true" width="700">
      <div style="text-align: center">
        <div v-if="jpImageLoading">加载中...</div>
        <img
          v-else-if="jpImageUrl"
          :src="jpImageUrl"
          style="max-width: 100%; max-height: 520px"
        />
        <div v-else>暂无图片</div>
      </div>
    </Modal>

  </div>
</template>

<script>
import { cmsJPList, getJpimage } from "../../api/machine";


import { formatOssUrl } from "@/utils";

export default {
  data() {
    return {
      selUser: {},
      modal4: false,
      modal3: false,
      modal2: false, // 控制充值弹窗的显示与否
      rechargeType: "充值", // 充值或扣除的类型，"recharge"表示充值，"deduct"表示扣除
      currencyType: "金币", // 选择的类型，可以是"points"或"coins"
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      giftId: "", // 添加礼品ID字段
      isfengjin: false,
      modal1: false,
      jpImageModal: false,
      jpImageUrl: "",
      jpImageLoading: false,
      roomid: "",
      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "房间id",
          key: "roomid",
        },

        {
          title: "房间名",
          key: "roomname",
          render: (h, params) => {
                        const user_status = params.row.MachineRoom.roomname;

            return h(
              "span",
              user_status
            );
          },
        },
        {
          title: "奖励名称",
          key: "rewardname",
        },
        {
          title: "识别数值",
          key: "nnum",
        },
        {
          title: "识别时间",
          key: "createtimes",
        },
         {
          title: "状态",
          key: "ntype",
          render: (h, params) => {
            const user_status = params.row.ntype;
            const nnum = params.row.nnum;
            if(user_status == 0 && nnum!=0){
              return h(
              "span",
              "重复识别,不发放/识别名称有误,导致未发放"
            );
            }else{
              if(user_status == 0)
            {
              return h(
              "span",
              "识别失败"
            );
            }else{
              return  h(
              "span",
              "已发放"
            );
            }
            }
            
          },
        },
        
      
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [

              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.viewJpImage(params.row);
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      searchId: "",
      searchName: "",
      searchPhone: "",
      current: 1,
      total: 0,
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    viewJpImage(row) {
      const id = row && row.id != null ? row.id : undefined;
      if (id === undefined) {
        this.$Message.error("缺少id，无法查看图片");
        return;
      }

      this.jpImageModal = true;
      this.jpImageLoading = true;
      this.jpImageUrl = "";

      getJpimage({ id })
        .then((response) => {
          const data = response && response.data !== undefined ? response.data : response;
          const url =
            (data && data.url) ||
            (data && data.data) ||
            (data && data.rows) ||
            data;

          if (!url) {
            this.jpImageUrl = "";
            return;
          }

          this.jpImageUrl = typeof url === "string" ? formatOssUrl(url) : "";
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error("获取图片失败");
          this.jpImageUrl = "";
        })
        .finally(() => {
          this.jpImageLoading = false;
        });
    },
  
    guanbimodal() {
      this.modal3 = false;
      this.modal4 = false;
    },
    cancelFenghao() {
      this.modal1 = false;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsJPList(params)
        .then((response) => {
          const payload = response && response.data ? response.data : {};
          this.data9 = (payload && payload.data) || []; // 获取查询结果
          const nextPage =
            payload && payload.pagination ? payload.pagination.currentPage : undefined;
          this.current = typeof nextPage === "number" ? nextPage : this.current; // 获取当前页
          this.total =
            payload && payload.pagination ? payload.pagination.total : 0; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        userid: this.searchId || undefined,
        roomid: this.roomid || undefined,
        username: this.searchName || undefined,
        userphone: this.searchPhone || undefined,
        starttime,
        endtime,
        page: this.current,
        pageSize: 50,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.roomid = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
   
    cancelRecharge() {
      this.modal2 = false; // 关闭弹窗
    },
    handleCurrencyTypeChange(value) {
      if (value === '礼品') {
        this.rechargeType = '充值';
        this.amount = '';
      } else {
        this.giftId = '';
        this.amount = 0;
      }
    },
  },
};
</script>
